import Select, { SingleValue } from "react-select";
import { useSnapshot } from "valtio";
import { clientDashboardEvents, TreeNode } from "../clientDashboardEvents";
import { treeForStatus } from "../campaignDates";

type Option = { label: string; value: number | null };

const ALL_OPTION: Option = { label: "All Objectives", value: null };

export default function ObjectiveSelect() {
    const snap = useSnapshot(clientDashboardEvents);
    const tree = treeForStatus(snap.filterTree as TreeNode[], snap.status);

    if (!snap.engagement) return null;

    const engagement = tree.find((e) => e.id === snap.engagement);
    if (!engagement || !engagement.children.length) return null;

    const options: Option[] = [
        ALL_OPTION,
        ...engagement.children.map((o) => ({ label: o.name, value: o.id })),
    ];
    const selected = options.find((o) => o.value === snap.objective) ?? ALL_OPTION;

    return (
        <div className="dash-filter">
            <Select<Option, false>
                options={options}
                value={selected}
                onChange={(opt: SingleValue<Option>) => {
                    clientDashboardEvents.triggerObjectiveChanged(opt?.value ?? null);
                }}
                menuPlacement="bottom"
                isClearable={false}
            />
        </div>
    );
}
